import { workSections } from './workSections'
import { composeStep } from './thoughtTimelineSummarySteps'
import { detailSteps } from './thoughtTimelineExtrasSteps'

export function buildThoughtTimelineExtras({
  thoughtSummary,
  thoughtDetails = [],
  workStatus,
  runId,
  streaming = false,
  hasPublicTimeline = false,
  phaseTitles = [],
  phaseKinds = [],
  hasResponseText = false,
}) {
  const leading = []
  const trailing = []
  if (hasPublicTimeline && workStatus) {
    const plan = workSections(workStatus, [], runId).plan
    if (plan.length) leading.push({ kind: 'plan', tasks: plan })
  }
  leading.push(...detailSteps(thoughtDetails, streaming))
  const compose = composeStep({
    streaming,
    thoughtSummary,
    phaseKinds,
    phaseTitles,
    hasResponseText,
  })
  if (compose) trailing.push(compose)
  return { leading, trailing }
}

export function hasThoughtTimelineExtras({ leading = [], trailing = [] } = {}) {
  return leading.length > 0 || trailing.length > 0
}
